function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

$(function () {
  // 新着順にソート
  $itemArray.sort(function(a,b) {
    // return (a.published_at < b.published_at ? 1 : -1);
    return b.price - a.price;
  });
  $recipeArray.sort(function(a,b) {
    // return (a.published_at < b.published_at ? 1 : -1);
    return b.price - a.price;
  });

  $('.error_msg_product').text('')
  $('.error_msg_recipe').text('')


  let searchKeyWord = getParam('p');
  if (searchKeyWord) {
    let addText = '検索キーワード：' + searchKeyWord;
    $('.search_text').text(addText);
  }

  let searchTagWord = getParam('tg');
  if (searchTagWord) {
    let addText = '検索タグ：＃' + searchTagWord;
    $('.search_text').text(addText);
  }


  let collectionItem = '#collection_item';
  let collectionRecipe = '#collection_recipe';

  let viewCout = 6;

  let currentPage = 1;
  let startSlice = (currentPage - 1) * viewCout;
  let endSlice = viewCout * currentPage;

  // let $itemResultArray = $.grep($itemArray,
  //   function(elem, index) {
  //     regexp = new RegExp(searchKeyWord + '(.*?)', 'g');
  //     return (elem.title.match(regexp));
  //   }
  // );
  function moreBtn(resultArray, endCnt, targetName) {
    if (resultArray.length <= endCnt) {
      $(targetName).css({'display':'none'});
    }
  }

  let $itemResultArray = $.grep($itemArray,
    function(elem, index) {
      if (searchKeyWord) {
        regexp = new RegExp(searchKeyWord + '(.*?)', 'g');
        return (elem.title.match(regexp));
      } else if(searchTagWord) {
        return (elem.tags.indexOf(searchTagWord) > -1);
      }
    }
  );
  let $firstItemArray = $itemResultArray.slice(startSlice,endSlice);

  if ($firstItemArray.length <= 0) {
    $('.error_msg_product').text('対象の商品はございません。');
    $(collection_item).css({'display':'none'});
    $('#collection_item_btn').css({'display':'none'});
  }
  moreBtn($itemResultArray, endSlice, '#collection_item_btn');



  let recipeCurrentPage = 1;
  let recipeStartSlice = (recipeCurrentPage - 1) * viewCout;
  let recipeEndSlice = viewCout * recipeCurrentPage;

  let $recipeResultArray = $.grep($recipeArray,
    function(elem, index) {
      if (searchKeyWord) {
        regexp = new RegExp(searchKeyWord + '(.*?)', 'g');
        return (elem.title.match(regexp));
      } else if(searchTagWord) {
        return (elem.tags.indexOf(searchTagWord) > -1);
      }
    }
  );
  let $firstRecipeArray = $recipeResultArray.slice(recipeStartSlice,recipeEndSlice);

  if ($firstRecipeArray.length <= 0) {
    $('.error_msg_recipe').text('対象のレシピはございません。');
    $(collectionRecipe).css({'display':'none'});
    $('#collection_recipe_btn').css({'display':'none'});
  }
  moreBtn($recipeResultArray, recipeEndSlice, '#collection_recipe_btn');



  $('#collection_item_btn').on('click',function(){
    currentPage++;

    let startSlice = (currentPage - 1) * viewCout;
    let endSlice = viewCout * currentPage;
    let $sliceItemArray = $itemResultArray.slice(startSlice,endSlice);
    moreBtn($itemResultArray, endSlice, '#collection_item_btn');
    collectionItemView($sliceItemArray);
    return false;
  })

  $('#collection_recipe_btn').on('click',function(){
    recipeCurrentPage++;

    let recipeStartSlice = (recipeCurrentPage - 1) * viewCout;
    let recipeEndSlice = viewCout * recipeCurrentPage;
    let $sliceItemArray = $recipeResultArray.slice(recipeStartSlice,recipeEndSlice);
    moreBtn($recipeResultArray, recipeEndSlice, '#collection_recipe_btn');

    collectionRecipeView($sliceItemArray);
    return false;
  })


  collectionItemView($firstItemArray);

  function collectionItemView($productArray) {
    $.each($productArray, function (i, citem) {
      var addDom = '<li>'+
                    '<a href="'+citem['url']+'">'+
                      '<div class="thumbnail">'+
                        '<img src="'+citem['img']+'" alt="'+citem['title']+'">'+
                      '</div>'+
                      '<p class="name">'+citem['title']+'</p>'+
                      '<p class="detail">'+citem['content']+'</p>'+
                      '<p class="jancode">JANコード:<br class="sp"><span>'+citem['jancode']+'</span></p>'+
                      '<div class="more">'+
                        '<p>商品情報を見る &gt;</p>'+
                      '</div>'+
                    '</a>'+
                  '</li>';
      $(collectionItem).append(addDom);
    })
  }



  collectionRecipeView($firstRecipeArray);

  function collectionRecipeView($productArray) {
    $.each($productArray, function (i, citem) {
      var addDom =
      '<li>'+
        '<a href="'+citem['url']+'">'+
          '<div class="thumbnail"><img src="'+citem['img']+'" alt="'+citem['title']+'"></div>'+
            '<p class="name">'+citem['title']+'</p>'+
            '<p class="detail">'+citem['content']+'</p>'+
            '<ul class="tags">'+
                '<li class="normal">'+citem['genre']+'</li>'+
                '<li class="red">'+citem['product_used']+'</li>'+
            '</ul>'+
            '<div class="meta_content">'+
              '<dl>'+
                  '<dt>'+
                      '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">'+
                          '<g transform="translate(-150 -1598)">'+
                              '<g transform="translate(150 1598)" fill="#fff" stroke="#ee220c" stroke-width="1">'+
                                  '<circle cx="7.5" cy="7.5" r="7.5" stroke="none"></circle>'+
                                  '<circle cx="7.5" cy="7.5" r="7" fill="none"></circle>'+
                              '</g>'+
                              '<path d="M157.5,1600.867v4.822l2.81,2.81" fill="none" stroke="#ee220c" stroke-width="1">'+
                              '</path>'+
                          '</g>'+
                      '</svg>'*
                    '</dt>'+
                    '<dd><span>'+citem['cooking_time']+'</span>分</dd>'+
                '</dl>'+
                '<dl>'+
                  '<dt>'+
                    '<svg xmlns="http://www.w3.org/2000/svg" width="11.378" height="20.924" viewBox="0 0 11.378 20.924">'+
                        '<g transform="translate(-1284.015 -439.75)">'+
                          '<path d="M1292.271,444.891a2.463,2.463,0,0,1-.841-1.8c0-1.569,1.662-2.84,3.713-2.84s3.713,1.272,3.713,2.84A2.467,2.467,0,0,1,1298,444.9"'+
                              'transform="translate(-5.459)" fill="none" stroke="#ee220c" stroke-miterlimit="10"'+
                              'stroke-width="1"></path>'+
                          '<rect width="6.957" height="1.873" rx="0.936" transform="translate(1286.164 444.881)" fill="none" stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></rect>'+
                          '<path d="M1286.782,470.87v.486a.458.458,0,0,1-.138.328l-.748.733a.738.738,0,0,0-.216.438l-1.154,9.625a1.417,1.417,0,0,0,1.313,1.579,22.812,22.812,0,0,0,4.092.292"'+
                              'transform="translate(0 -24.178)" fill="none" stroke="#ee220c" stroke-miterlimit="10"'+
                              'stroke-width="1"></path>'+
                          '<path d="M1311.242,470.87v.486a.459.459,0,0,0,.138.328l.748.733a.737.737,0,0,1,.216.438l1.154,9.625a1.417,1.417,0,0,1-1.313,1.579,22.812,22.812,0,0,1-4.092.292"'+
                              'transform="translate(-18.616 -24.178)" fill="none" stroke="#ee220c"'+
                              'stroke-miterlimit="10" stroke-width="1"></path>'+
                          '<line x2="4.508" transform="translate(1287.399 448.648)" fill="none" stroke="#ee220c"'+
                              'stroke-miterlimit="10" stroke-width="1"></line>'+
                          '<line y1="2.593" x2="0.167" transform="translate(1288.034 448.627)" fill="none"'+
                              'stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></line>'+
                          '<line y1="6.793" x2="0.439" transform="translate(1287.523 452.352)" fill="none"'+
                              'stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></line>'+
                          '<line x2="0.202" y2="3.149" transform="translate(1291.602 456.078)" fill="none"'+
                              'stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></line>'+
                          '<line x2="0.41" y2="6.379" transform="translate(1291.125 448.648)" fill="none"'+
                              'stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></line>'+
                          '<circle cx="0.288" cy="0.288" r="0.288" transform="translate(1287.873 441.794)" fill="none"'+
                              'stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></circle>'+
                          '<circle cx="0.288" cy="0.288" r="0.288" transform="translate(1290.898 441.794)" fill="none"'+
                              'stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></circle>'+
                          '<circle cx="0.288" cy="0.288" r="0.288" transform="translate(1289.385 441.464)" fill="none"'+
                              'stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></circle>'+
                          '<circle cx="0.288" cy="0.288" r="0.288" transform="translate(1287.873 440.6)" fill="none"'+
                              'stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></circle>'+
                          '<circle cx="0.288" cy="0.288" r="0.288" transform="translate(1290.898 440.6)" fill="none"'+
                              'stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></circle>'+
                          '<circle cx="0.288" cy="0.288" r="0.288" transform="translate(1289.385 440.271)" fill="none"'+
                              'stroke="#ee220c" stroke-miterlimit="10" stroke-width="1"></circle>'+
                      '</g>'+
                    '</svg>'+
                  '</dt>'+
                  '<dd><span>'+citem['salt']+'</span>g</dd>'+
                '</dl>'+
                '<dl>'+
                    '<dt>'+
                        '<svg xmlns="http://www.w3.org/2000/svg" width="13.7" height="19.101" viewBox="0 0 13.7 19.101">'+
                            '<g transform="translate(-1712.957 -455.176)">'+
                                '<path d="M1724.348,486.816c0-2.846,1.423-3.714,2.568-4.859a2.952,2.952,0,0,0,1,2.62c1.432.946,2.916,1.016,2.89,2.864a3.245,3.245,0,0,1-3.228,3.228C1725.793,490.669,1724.348,488.9,1724.348,486.816Z"'+
                                    'transform="translate(-7.993 -19.287)" fill="none" stroke="#ee220c"'+
                                    'stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>'+
                                '<path '+
                                    'd="M1718.919,455.676a3.858,3.858,0,0,1,2.538,3.4c0,1.006-.486,1.423-.486,2.412a1.6,1.6,0,0,0,3.193,0,1.709,1.709,0,0,0-.06-.537c1.8,1.84,2.247,3.14,2.021,6.49a6.5,6.5,0,0,1-6.335,6.335,6.335,6.335,0,0,1-6.335-6.335C1713.457,461.49,1717.774,461.681,1718.919,455.676Z"'+
                                    'transform="translate(0 0)" fill="none" stroke="#ee220c" stroke-linecap="round"'+
                                    'stroke-linejoin="round" stroke-width="1"></path>'+
                            '</g>'+
                        '</svg>'+
                    '</dt>'+
                    '<dd><span>'+citem['calorie']+'</span>kcal</dd>'+
                '</dl>'+
            '</div>'+
          '</a>'+
      '</li>';
      $(collectionRecipe).append(addDom);
    })
  }



});